import React from "react";

import { Checkbox } from "../../UI/Checkbox";
import { TableCell } from "../../UI/TableCell";
import { TableHead } from "../../UI/TableHead";
import { TableRow } from "../../UI/TableRow";
import { EnhancedTable } from "../EnhancedTable";
import { Switch } from "../../components/Switch";
import { EnhancedTableBody } from "../EnhancedTableBody";
import { ReadOnlyWrapper } from "../ReadOnlyWrapper";
import useAuth from "../../routes/login/AuthContext";
import { useSelectedNetworkImportTypes } from "../../hooks/useSelectedNetworkImportType";


const TITLE_TOOLTIP_CONTENT =
  "This is an automatic email sent to all residents who haven't registered yet for RoomSync. The number of days indicated is the number of days after they were first imported to RoomSync. You can choose to send none, some, or all of these reminders by checking or unchecking boxes. If the matching dates have expired, this reminder email will not be sent to users.";

const TITLE_TOOLTIP_PDF_ACC = {
  link: "/static/pdf/invitation_reminder_email_acc.png",
  text: "View an example of this email communication"
};

const TITLE_TOOLTIP_PDF_ENTRATA_RMG_RMBG = {
  link: "/static/pdf/invitation_reminder_email_entrata_rms_rmbg.png",
  text: "View an example of this email communication"
};

interface IProps {
  l2Name: string;
  setEntrataEmailNotification: any;
  emailDetails: any;
  isDisabled?: boolean;
}

export const EntrataReminderNotificationsTable: React.FC<IProps> = (props) => {
  const { isSuperAdminRead } = useAuth();
  const { isAcc, isEntrata, isRms, isRmbg, isKinetic } = useSelectedNetworkImportTypes();


  const handleCheckboxToggle = (cell: "twentyOneDayReminder" | "tenDayReminder" | "threeDayReminder") => (e: any) => {
    props.setEntrataEmailNotification({ ...props.emailDetails, [cell]: e.target.checked });
  };

  const handleSwitchTootle = (e: any, checked: boolean) =>
    props.setEntrataEmailNotification({
      ...props.emailDetails,
      enabled: checked,
    });

  const tooltipPdf = () => {
    if(isAcc) {
      return TITLE_TOOLTIP_PDF_ACC;
    }
    if(isEntrata || isRms || isRmbg || isKinetic) {
      return TITLE_TOOLTIP_PDF_ENTRATA_RMG_RMBG;
    }
    return;
  };

  return (
    <EnhancedTable
      title="Invitation Reminder Email"
      titleHelpTooltip={TITLE_TOOLTIP_CONTENT}
      urlHelpTooltip={tooltipPdf()}
      titleEndAdorment={
        <ReadOnlyWrapper>
          <Switch
            isDisabled={isSuperAdminRead() || props.isDisabled}
            switchProps={{
              checked: props.emailDetails.enabled,
              onChange: handleSwitchTootle,
            }}
          />
        </ReadOnlyWrapper>
      }
    >
      <TableHead secondary>
        <TableRow>
          <TableCell>Subnetwork Name</TableCell>
          <TableCell>3 Days</TableCell>
          <TableCell>10 Days</TableCell>
          <TableCell>21 Days</TableCell>
        </TableRow>
      </TableHead>
      <EnhancedTableBody colSpan={4}>
        <TableRow>
          <TableCell>{props.l2Name}</TableCell>
          <TableCell>
            <ReadOnlyWrapper>
              <Checkbox
                isDisabled={isSuperAdminRead() || props.isDisabled}
                name="threeDayReminder"
                isChecked={props.emailDetails.threeDayReminder}
                onChange={handleCheckboxToggle("threeDayReminder")}
              />
            </ReadOnlyWrapper>
          </TableCell>
          <TableCell>
            <ReadOnlyWrapper>
              <Checkbox
                isDisabled={isSuperAdminRead() || props.isDisabled}
                name="tenDayReminder"
                isChecked={props.emailDetails.tenDayReminder}
                onChange={handleCheckboxToggle("tenDayReminder")}
              />
            </ReadOnlyWrapper>
          </TableCell>
          <TableCell>
            <ReadOnlyWrapper>
              <Checkbox
                isDisabled={isSuperAdminRead() || props.isDisabled}
                name="twentyOneDayReminder"
                isChecked={props.emailDetails.twentyOneDayReminder}
                onChange={handleCheckboxToggle("twentyOneDayReminder")}
              />
            </ReadOnlyWrapper>
          </TableCell>
        </TableRow>
      </EnhancedTableBody>
    </EnhancedTable>
  );
};
